import AuditIcon from 'assets/icon/audit.svg';
import TransmissionIcon from 'assets/icon/vector.svg';
import { EmptyStateWithText } from 'components/EmptyState';
import routePaths from 'constants/route-paths';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import AsideListIconComponent, { AsideListIcon } from '../common/AsideIconMenuItem';

const IndicatorsAsideMenu = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [chosen, setChosen] = useState<string>();

  const asideListIcons: AsideListIcon[] = [
    {
      label: t('audit'),
      routePath: routePaths.INDICATORS_AUDIT,
      svgIcon: AuditIcon,
    },
    {
      label: t('transmission'),
      routePath: routePaths.INDICATORS_TRANSMISSION,
      svgIcon: TransmissionIcon,
    },
    {
      label: t('archive'),
      routePath: routePaths.INDICATORS_ARCHIVE,
      svgIcon: AuditIcon,
    },
  ];

  useEffect(() => {
    setChosen(location.pathname);
  }, [location]);

  return (
    <div className="aside-menu">
      <ul className="menu-nav py-0">
        {asideListIcons.length ? (
          asideListIcons.map((listItem) => (
            <AsideListIconComponent
              key={listItem.label}
              icon={listItem}
              active={listItem.routePath === chosen}
              onClick={() => {
                setChosen(listItem.routePath);
              }}
            />
          ))
        ) : (
          <EmptyStateWithText text={t('no_results_for_current_settings')} verticalPositionTop />
        )}
      </ul>
    </div>
  );
};

export default IndicatorsAsideMenu;
